import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA } from 'src/app/constantes/permissao.constants';
import { Arquivo, LabelTipoConteudo, TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';
import { consultaIpocExemplo } from 'src/app/model/consulta-ipoc.model';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { JanelaEnvioProtocolo, ProtocoloArquivo, StatusProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { recuperacaoCreditoExemplo } from 'src/app/model/recuperacao-credito.model';
import { solicitacaoHonraExemplo, solicitacaoHonraExemploFGT } from 'src/app/model/solicitacao-honra.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { FileUtilsService } from '../file-utils.service';
import { OcorrenciaValidacaoVO } from '../ocorrencia-validacao.vo';
import { ProtocoloArquivoService } from '../services/protocolo-arquivo.service';
import { ModalidadeService } from '../services/modalidade.service';
import { MODALIDADE_GARANTIA_FGT } from 'src/app/model/modalidade_garantia.model';

@Component({
    selector: 'app-protocolo-envio',
    templateUrl: './protocolo-envio.component.html',
    styleUrls: ['./protocolo-envio.component.scss'],
    standalone: false
})
export class ProtocoloEnvioComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild(BnConfirmDirective, {static: false}) bnConfirm: BnConfirmDirective;

  @Input() titulo: string;
  @Input() instrucoesEnvio: string;
  @Input() janelaEnvioAtual: JanelaEnvioProtocolo;
  @Input() routerLinkEnvioLote: string; // ex.: '['/operacoes/cadastro/lote']
  @Input() routerLinkPesquisaLote: string;
  @Input() tipoConteudoArquivo: TipoConteudo;
  @Input() textoBtnArquivoExemplo: string;
  @Input() tipoArquivoExemplo: string;
  @Input() tipoArquivoAceito: string;
  @Input() mostrarBotoesDeOpcao: boolean = true;
  @Input() permitirForaJanela: boolean = false;
  @Output() aoEnviarArquivo: EventEmitter<any> = new EventEmitter();
  protocoloForm: UntypedFormGroup;

  arquivo: Arquivo;
  labelTipoConteudo: string;
  filecontentTemplate = '';
  janelaEnvioAberta = true;
  mensagemAlerta: string = undefined;
  protocoloPrevioValidoNaMesmaJanela: ProtocoloArquivo = undefined;

  private enviado: boolean;

  private ocorrencias: OcorrenciaValidacaoVO[] = [];

  private cnpjUsuario: string;
  private isAgente: boolean;
  private dataAtualBackend: any = undefined;
  private permitirCarregado:boolean = false;
  private utilizaTaxaAtualizacaoGarantia: boolean = false;
  private siglaModalidade: string;
  private readonly destroy$ = new Subject();

  vc: BnConfirmDirective;

  // tslint:disable-next-line:max-line-length
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private bnAlertsService: BnAlertsService,
    private modalService: BnModalMessageService,
    private fileUtils: FileUtilsService,
    private bnUsuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private removerAlertasService: RemoverAlertasService,
    private messageService: MessageChannelService,
    private protocoloArquivoService: ProtocoloArquivoService,
    private loadingService: BnLoadingService,
    private modalidadeService: ModalidadeService,
    ) {
    this.arquivo = new Arquivo();

    this.protocoloArquivoService.getTimeStampISO().pipe(takeUntil(this.destroy$)).subscribe(ts => {
      this.dataAtualBackend = ts;
      //console.debug(`dataAtualBackend: ${JSON.stringify(this.dataAtualBackend)}`);
    });

    this.bnUsuarioService.usuario$.pipe(takeUntil(this.destroy$)).subscribe(usuario => {
      this.cnpjUsuario = usuario.cnpj;
      //console.debug(`obteve cnpjUsuario:  ${this.cnpjUsuario}`);
    });
  }

  ngOnInit() {

    this.createReactiveForm();

    this.permissaoService.getPermissoesUsuarioAutenticado().pipe(takeUntil(this.destroy$)).subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.modalidadeService.modalidade$
      .pipe(takeUntil(this.destroy$))
      .subscribe(siglaModalidade => {
        if (siglaModalidade != null) {
          this.modalidadeService.getModalidadesAssincrono()
            .pipe(takeUntil(this.destroy$))
            .subscribe(modalidades => {
              const modalidade = modalidades.find(modalidade => modalidade.sigla === siglaModalidade);
              this.utilizaTaxaAtualizacaoGarantia = modalidade?.utilizaTaxaAtualizacaoGarantia ?? false;
              this.siglaModalidade = siglaModalidade;
            });
        }
      });

  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

   createReactiveForm() {
    this.protocoloForm = this.formBuilder.group({
      arquivo: ['', Validators.required],
      opcaoEnvio: ['', validadorBotoesOpcaoEnvio(this.mostrarBotoesDeOpcao)]
    });
  }

  ngOnChanges() {

    if (this.janelaEnvioAtual) {

      this.janelaEnvioAberta = true;
      this.mensagemAlerta = '';
      const momentoAtual = moment(this.dataAtualBackend ?
             Utils.dataFromISO(this.dataAtualBackend.nowDateISO)
            :Utils.dataCorrente())
          .startOf('day');

      if (momentoAtual.isAfter(moment(this.janelaEnvioAtual.dataFechamento).startOf('day')) && !this.permitirForaJanela) {
        if (this.tipoConteudoArquivo == TipoConteudo.ATUALIZACAO_INFO_RISCO || this.tipoConteudoArquivo == TipoConteudo.ACOMPANHAMENTO_PROCESSUAL) {

          this.mensagemAlerta = 'A janela de envio de arquivos deste ano foi encerrada.';
        }
        else {
          this.mensagemAlerta = 'A janela de envio de arquivos para o mês atual foi encerrada. Aguardar a' +
          ' abertura da janela do mês seguinte.';
        }
        this.janelaEnvioAberta = false;
      } else  if (momentoAtual.isBefore(moment(this.janelaEnvioAtual.dataAbertura).startOf('day'))) {
        if (this.tipoConteudoArquivo == TipoConteudo.ATUALIZACAO_INFO_RISCO || this.tipoConteudoArquivo == TipoConteudo.ACOMPANHAMENTO_PROCESSUAL) {
          this.mensagemAlerta = 'A janela de envio de arquivos deste ano ainda não está aberta.';
        }
        else {
          this.mensagemAlerta = 'A janela de envio de arquivos para o mês atual ainda não está aberta.';
        }
        this.janelaEnvioAberta = false;
      }
      if (this.janelaEnvioAberta) {
        this.verificarExistenciaDeArquivoValidoNaMesmaJanelaDeEnvio();
      }
    }
  }

  onFileChange(event) {

    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    this.protocoloForm.markAsDirty();
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      if (!this.suportaTamArquivo(file.size)) {
        console.log(`Arquivo muito grande ${file.size} bytes`);
        // A mensagem abaixo não aparece se for chamada diretamente aqui
        // Acredito (jmaur) que é por esta em tratamento de evento
        // Colocá-la em um processamento assíncrono (como o setTimeout()) resolve a questão
        setTimeout(() => {
          this.limpar();
          this.bnAlertsService.alertaErro('Erro', `O arquivo ${file.name} é muito grande. Reduza o tamanho do arquivo.`);
        }, 0);
        return;
      }

      reader.readAsText(file, 'UTF-8');
      reader.onload = () => {

        let conteudoArquivo = '';
        if (typeof reader.result === 'string') {
          conteudoArquivo = reader.result;
        } else {
          conteudoArquivo = this.fileUtils.lerConteudo(reader);
        }

        // evitar erros com estas aspas estranhas
        conteudoArquivo = conteudoArquivo.replace('“', '"').replace('”', '"');

        const isArquivoValido = this.validarArquivo(file.name, file.type, conteudoArquivo);
        if (!isArquivoValido) {
          return;
        }

        this.arquivo = new Arquivo();
        this.arquivo.filename = file.name;
        this.arquivo.filetype = file.type;
        this.arquivo.value = conteudoArquivo;
        this.arquivo.tipoConteudo = this.tipoConteudoArquivo;
        this.labelTipoConteudo = LabelTipoConteudo.get(this.arquivo.tipoConteudo);

        this.protocoloForm.updateValueAndValidity();
      };
    }
  }

  onSubmit() {
    //alert(this.tipoArquivoAceito);
    if (!this.arquivo.value) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não possui conteúdo.');
      return;
    }

    const opcaoEnvioStr = this.protocoloForm.get('opcaoEnvio').value;
    const apenasValidar = (opcaoEnvioStr === 'validar');

    const exibirMensagemSucesso = (res) => {
      this.loadingService.liberaTela();

      const msgRetorno: MensagemRetornoAssincrono = res;
      const mensagemSucesso = `${msgRetorno.mensagem} Id de protocolo: ${msgRetorno.idProtocolo}`;

      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: mensagemSucesso
      });
      this.limpar();

      // retorna a pagina de envio do arquivo em lote
      if (this.tipoConteudoArquivo === TipoConteudo.SOLICITACOES_HONRA) {
        this.router.navigate(['solicitacoes-honra/lote']);
      } else if (this.tipoConteudoArquivo === TipoConteudo.RECUPERACOES_CREDITO) {
        this.router.navigate(['recuperacoes-credito/lote']);
      }
    };

    const exibirMensagemErro = (err) => {
      this.loadingService.liberaTela();

      this.ocorrencias = this.protocoloArquivoService.ocorrencias;
      this.limpar();
    };

    if (apenasValidar || !this.protocoloPrevioValidoNaMesmaJanela) {
      this.enviar(exibirMensagemSucesso, exibirMensagemErro, apenasValidar);
    } else {
      this.solicitarConfirmacaoDoEnvio()
        .then(podeEnviar => {
          if (podeEnviar) {
            this.enviar(exibirMensagemSucesso, exibirMensagemErro, apenasValidar);
          }
       });
    }
  }

  private enviar(exibirMensagemSucesso, exibirMensagemErro, apenasValidar) {
    this.protocoloForm.disable();
    this.enviado = true;

    this.protocoloArquivoService.enviarArquivo(this.arquivo, this.arquivo.tipoConteudo, apenasValidar)
      .pipe(takeUntil(this.destroy$)).subscribe(exibirMensagemSucesso, exibirMensagemErro);
  }

  private limpar() {
    this.arquivo = null;
    this.protocoloForm.reset();
    this.protocoloForm.markAsPristine();
    this.protocoloForm.enable();
    this.protocoloForm.updateValueAndValidity();

    this.enviado = false;
  }

  private validarArquivo(nomeArquivo, tipoArquivo, conteudoArquivo): boolean {
    if (this.tipoArquivoAceito == 'csv') {
      return true;
    }

    if (tipoArquivo !== 'application/json') {
      this.bnAlertsService.alertaErro('Erro', `O sistema suporta apenas arquivos JSON - '${nomeArquivo}' --> '${tipoArquivo}'.`);
      this.limpar();
      return false;
    }

    if (conteudoArquivo === null || conteudoArquivo === '') {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo está vazio.');
      this.limpar();
      return false;
    }

    if (!Utils.isValidJson(conteudoArquivo)) {
      this.bnAlertsService.alertaErro('Erro', 'Não foi possível validar o arquivo JSON. ' +
        'Verifique se há erros de sintaxe no arquivo, como vírgulas mal colocadas ou chaves não fechadas. ' +
        'Uma sugestão é utilizar um dos vários sites de validação JSON disponíveis na web.');
      this.limpar();
      return false;
    }

    return true;
  }

  async solicitarConfirmacaoDoEnvio(): Promise<boolean> {
    const titulo = 'Confirmação';
    const mensagem = 'Já existe um arquivo válido enviado anteriormente para a janela corrente. Caso ' +
    'este arquivo seja válido, ele substituirá o anterior. Confirma o envio?';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  private verificarExistenciaDeArquivoValidoNaMesmaJanelaDeEnvio(): void {

     /* preenchimento dos filtros */
     const params: any = {};
     params.cnpjAgente = this.cnpjUsuario;
     params.statusProtocolo = StatusProtocolo.SUCESSO;
     params.dataEnvioInicial = moment(this.janelaEnvioAtual.dataAbertura).format('YYYYMMDD');
     params.dataEnvioFinal = moment(this.janelaEnvioAtual.dataFechamento).format('YYYYMMDD');
     params.apenasValidacao = false;
     params.tiposProtocolos = this.tipoConteudoArquivo;

     this.protocoloArquivoService.getArquivosPorAgente(params)
         .pipe(takeUntil(this.destroy$))
         .subscribe(response => {
             // no maximo, esperamos um elemento nesta lista (visto que so podemos ter um protocolo por janela)
             const protocolosPreviosMesmaJanela: ProtocoloArquivo[] = response ? response.resultados : undefined;
             if (protocolosPreviosMesmaJanela?.length > 0) {
                this.protocoloPrevioValidoNaMesmaJanela = protocolosPreviosMesmaJanela[0];
                const dataEnvio = moment(this.protocoloPrevioValidoNaMesmaJanela.dataEnvio).format('DD/MM/YYYY');
                const horaEnvio = moment(this.protocoloPrevioValidoNaMesmaJanela.dataEnvio).format('HH:mm');

                this.mensagemAlerta = 'Já existe um arquivo enviado para esta janela ' +
                  `em ${dataEnvio} às ${horaEnvio} (Id: ${this.protocoloPrevioValidoNaMesmaJanela.idProtocoloNegocio}). ` +
                  'O envio de um novo arquivo válido com a opção \'Efetivar envio\' substituirá o arquivo anterior.';
             }
     });

  }

  private suportaTamArquivo(fileSizeBytes: number): boolean {
    // tenta descobrir o quanto temos de memória
    let memSizeBytes;
    const perf: any = window.performance;
    if (perf.memory) {
      memSizeBytes = perf.memory.jsHeapSizeLimit;
    }

    if (memSizeBytes) {
      const limiteBytes = Math.round(memSizeBytes / 30); // Número mágico, apurado com algumas medições
      console.log(`limiteArquivo - estimado pela memória livre. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    } else {
      const limiteBytes = 64 * 1024 * 1024; // 64 MB deve caber em uma máquina com 8GB
      console.log(`limiteArquivo - valor fixo. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    }
  }

  baixarTabelaDeErros() {
    const ocorrenciasJson = JSON.stringify(this.ocorrencias);
    this.fileUtils.exportarArquivo('erros.json', ocorrenciasJson, FileUtilsService.APPLICATION_JSON);
  }

  preparaArquivoExemplo():void{
    if(this.tipoArquivoExemplo == "Ação IPOC"){
      this.preparaCSVDeArquivoExemplo();
    }
    else{
      this.preparaJsonDeArquivoExemplo();
    }
  }

  preparaCSVDeArquivoExemplo():void{
    let csv, nomeArquivo;
    nomeArquivo = 'exemplo-acao-ipoc.csv';
    csv = consultaIpocExemplo;
    this.fileUtils.exportarArquivo(nomeArquivo,csv,FileUtilsService.TEXT_CSV)

  }

  preparaJsonDeArquivoExemplo(): void{
    let json, nomeArquivo;

    if(this.tipoArquivoExemplo == "Recuperação de Crédito"){
      json = JSON.parse(recuperacaoCreditoExemplo);
      nomeArquivo = 'exemplo-recuperacao-credito.json';
    } else{
      json = JSON.parse(solicitacaoHonraExemplo);
      nomeArquivo = 'exemplo-solicitacao-honra.json'

      if (!this.utilizaTaxaAtualizacaoGarantia) {
        json.solicitacoesHonra = json.solicitacoesHonra.filter(sh => sh.sistemaRepasse != '84'
            && sh.contratoRepasse != '44444444444'
        );
      }

      if(this.siglaModalidade === MODALIDADE_GARANTIA_FGT){
        json = JSON.parse(solicitacaoHonraExemploFGT);
      }

    }

    json.cnpjAgenteFinanceiro = this.cnpjUsuario == undefined ? json.cnpjAgenteFinanceiro : this.cnpjUsuario;
    json = JSON.stringify(json, null, 4); // imprime versão "pretty"

    this.baixarArquivoExemplo(json, nomeArquivo);
  }

  baixarArquivoExemplo(json: string, nomeArquivo: string): void{
    this.fileUtils.exportarArquivo(nomeArquivo,
    json, FileUtilsService.APPLICATION_JSON);
  }

}

export function validadorBotoesOpcaoEnvio(mostrarBotoesDeOpcao: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if(mostrarBotoesDeOpcao){
      if(control.value){
        return null;
      }
      else {
        return {opcaoEnvioInvalid: true};
      }
    }
    else {
      return null;
    }
  };
}
